@if (showLdr) {
<ds-loading></ds-loading>
}
<div class="row hdrBar">
  <div class="col-lg-8 col-md-8 mg-a">
    @if (clntDtls && clntDtls.length > 0) {
    <h1>CDMA State Dashboard</h1>
    }
  </div>
  <div class="col-lg-4 col-md-4 mg-a" style="text-align: right">
    <span>Select Date:</span>
    <nz-date-picker
      [nzDisabledDate]="disabledDate"
      [nzFormat]="dateFormat"
      [(ngModel)]="slctdDt"
      (ngModelChange)="onChange($event)"
    ></nz-date-picker>
  </div>
</div>
<div class="main">
  <div class="row">
    <div class="row bg-wp" style="padding: 2px 10px 2px 20px; margin: 0px 10px">
      <h1
        class="hdrTxt_sm hdrSdLblf"
        style="text-align: center; text-transform: capitalize"
      >
        URBAN
      </h1>
      <ul class="cards">
        @for (d of tdyCoveredTrips; track d) {
        <li class="cards_item">
          <div
            class="card_g"
            style="
              background: linear-gradient(135deg, #63badb 0%, #35a1af 100%);
            "
            (click)="cardOne()"
            [ngClass]="crdOne == true ? 'active_class' : 'normalclass'"
          >
            <div class="card_content">
              <div class="row">
                <h1 class="crdHdr">Vehicles</h1>
              </div>
              <div class="row">
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{ d.actve_urbn_ttl === null ? "0" : d.actve_urbn_ttl }}
                  </h1>
                  <h1 class="card_sub_title">Active</h1>
                </div>
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{ d.inact_urbn_ttl === null ? "0" : d.inact_urbn_ttl }}
                  </h1>
                  <h1 class="card_sub_title">Spare</h1>
                </div>
              </div>
            </div>
          </div>
        </li>
        } @for (d of tdyCoveredTrips; track d) {
        <li class="cards_item">
          <div
            class="card_g"
            style="
              background: linear-gradient(135deg, #7f75e5 0%, #4e49b9 100%);
            "
            (click)="cardTwo()"
            [ngClass]="crdTwo == true ? 'active_class' : 'normalclass'"
          >
            <div class="card_content">
              <div class="row">
                <h1 class="crdHdr">Operational Status</h1>
              </div>
              <div class="row">
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{ d.u_operated === null ? "0" : d.u_operated }}
                  </h1>
                  <h1 class="card_sub_title">Operated</h1>
                </div>
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{ d.u_opper === null ? "0" : d.u_opper }} %
                  </h1>
                  <h1 class="card_sub_title">Operated %</h1>
                </div>
              </div>
              <div class="row">
                <p class="crdFtr">
                  VEHICLES TRAVELLED > 500 Meters IS CONSIDERED AS OPERATED
                </p>
              </div>
            </div>
          </div>
        </li>
        } @for (d of ttlDstncCnt; track d) {
        <li class="cards_item">
          <div
            class="card_g"
            style="
              background: linear-gradient(135deg, #9267d9 0%, #683eb5 100%);
            "
            (click)="cardThree()"
            [ngClass]="crdThree == true ? 'active_class' : 'normalclass'"
          >
            <div class="card_content">
              <div class="row">
                <h1 class="crdHdr">Vehicles Travelled</h1>
              </div>
              <div class="row">
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{
                      d.urbn_tdydst_abv30 === null ? "0" : d.urbn_tdydst_abv30
                    }}
                  </h1>
                  <h1 class="card_sub_title">>= 30km</h1>
                </div>
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{
                      d.urbn_tdydst_blw30 === null ? "0" : d.urbn_tdydst_blw30
                    }}
                  </h1>
                  <h1 class="card_sub_title">< 30km</h1>
                </div>
              </div>
            </div>
          </div>
        </li>
        } @for (d of ttlTrpsCnt; track d) {
        <li class="cards_item">
          <div
            class="card_g"
            style="
              background: linear-gradient(135deg, #63b5f5 0%, #449ee5 100%);
            "
            (click)="cardFour()"
            [ngClass]="crdFour == true ? 'active_class' : 'normalclass'"
          >
            <div class="card_content">
              <div class="row">
                <h1 class="crdHdr">Trips covered</h1>
              </div>
              <div class="row">
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{ d.tdy_trps === null ? 0 : d.tdy_trps }}
                  </h1>
                  <h1 class="card_sub_title">Trips</h1>
                </div>
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{ d.tdy_per === null ? 0 : d.tdy_per }} %
                  </h1>
                  <h1 class="card_sub_title">Trips covered%</h1>
                </div>
              </div>
            </div>
          </div>
        </li>
        }
      </ul>

      <!-- Trips & Routes Card - URBAN -->
      @if (ttlTrpsCnt && ttlTrpsCnt.length > 0) {
      <div class="tripsRoutesCard">
        <div class="trips-routes-container">
          <h1 class="hdrTxt_sm" style="text-align: center; margin-bottom: 10px">
            Trips & Routes (URBAN)
          </h1>
          <div class="trips-routes-grid">
            <!-- Top Row: Overall Counts -->
            <div class="tr-row">
              <div class="tr-card tr-indigo">
                <h1 class="tr-value">
                  {{ ttlTrpsCnt[0].trps_asgnd_vhcls || 0 }}
                </h1>
                <p class="tr-label">Trips Defined Vehicles</p>
              </div>
              <div class="tr-card tr-red">
                <h1 class="tr-value">
                  {{ ttlTrpsCnt[0].trps_not_asgnd_vhcls || 0 }}
                </h1>
                <p class="tr-label">Trips Not Defined Vehicles</p>
              </div>
              <div class="tr-card tr-teal">
                <h1 class="tr-value">
                  {{ ttlTrpsCnt[0].rts_dfnd_vhcls || 0 }}
                </h1>
                <p class="tr-label">Routes Defined Vehicles</p>
              </div>
              <div class="tr-card tr-orange">
                <h1 class="tr-value">
                  {{ ttlTrpsCnt[0].rts_not_dfnd_vhcls || 0 }}
                </h1>
                <p class="tr-label">Routes Not Defined Vehicles</p>
              </div>
            </div>
            <!-- Primary & Secondary Sections -->
            <div class="tr-sections">
              <!-- Primary Section -->
              <div class="tr-section tr-primary-section">
                <h2 class="tr-section-title">Primary</h2>
                <div class="tr-section-grid">
                  <div class="tr-sub-section">
                    <p class="tr-sub-title">Trips Vehicles</p>
                    <div class="tr-sub-row">
                      <div class="tr-mini-card tr-blue">
                        <span class="tr-mini-value">{{
                          ttlTrpsCnt[0].primary_trps_asgnd_vhcls || 0
                        }}</span>
                        <span class="tr-mini-label">Defined</span>
                      </div>
                      <div class="tr-mini-card tr-red-light">
                        <span class="tr-mini-value">{{
                          ttlTrpsCnt[0].primary_trps_not_asgnd_vhcls || 0
                        }}</span>
                        <span class="tr-mini-label">Not Defined</span>
                      </div>
                    </div>
                  </div>
                  <div class="tr-sub-section">
                    <p class="tr-sub-title">Routes Vehicles</p>
                    <div class="tr-sub-row">
                      <div class="tr-mini-card tr-teal-light">
                        <span class="tr-mini-value">{{
                          ttlTrpsCnt[0].primary_rts_dfnd_vhcls || 0
                        }}</span>
                        <span class="tr-mini-label">Defined</span>
                      </div>
                      <div class="tr-mini-card tr-orange-light">
                        <span class="tr-mini-value">{{
                          ttlTrpsCnt[0].primary_rts_not_dfnd_vhcls || 0
                        }}</span>
                        <span class="tr-mini-label">Not Defined</span>
                      </div>
                    </div>
                  </div>
                  <div class="tr-sub-section">
                    <p class="tr-sub-title">Trips</p>
                    <div class="tr-sub-row">
                      <div class="tr-mini-card tr-blue">
                        <span class="tr-mini-value">{{
                          ttlTrpsCnt[0].primary_def_trps || 0
                        }}</span>
                        <span class="tr-mini-label">Defined</span>
                      </div>
                      <div class="tr-mini-card tr-green">
                        <span class="tr-mini-value">{{
                          ttlTrpsCnt[0].primary_trvl_trps || 0
                        }}</span>
                        <span class="tr-mini-label">Travelled</span>
                      </div>
                      <div class="tr-mini-card tr-red-light">
                        <span class="tr-mini-value">{{
                          ttlTrpsCnt[0].primary_nt_trvl_trps || 0
                        }}</span>
                        <span class="tr-mini-label">Not Travelled</span>
                      </div>
                    </div>
                  </div>
                  <div class="tr-sub-section">
                    <p class="tr-sub-title">Routes</p>
                    <div class="tr-sub-row">
                      <div class="tr-mini-card tr-indigo-light">
                        <span class="tr-mini-value">{{
                          ttlTrpsCnt[0].primary_rts_dfnd || 0
                        }}</span>
                        <span class="tr-mini-label">Defined</span>
                      </div>
                      <div class="tr-mini-card tr-green">
                        <span class="tr-mini-value">{{
                          ttlTrpsCnt[0].primary_trckd_rts || 0
                        }}</span>
                        <span class="tr-mini-label">Tracked</span>
                      </div>
                      <div class="tr-mini-card tr-purple">
                        <span class="tr-mini-value">{{
                          ttlTrpsCnt[0].primary_rte_dvtd || 0
                        }}</span>
                        <span class="tr-mini-label">Deviated</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Secondary Section -->
              <div class="tr-section tr-secondary-section">
                <h2 class="tr-section-title">Secondary</h2>
                <div class="tr-section-grid">
                  <div class="tr-sub-section">
                    <p class="tr-sub-title">Trips Vehicles</p>
                    <div class="tr-sub-row">
                      <div class="tr-mini-card tr-orange-light">
                        <span class="tr-mini-value">{{
                          ttlTrpsCnt[0].secondary_trps_asgnd_vhcls || 0
                        }}</span>
                        <span class="tr-mini-label">Defined</span>
                      </div>
                      <div class="tr-mini-card tr-red-light">
                        <span class="tr-mini-value">{{
                          ttlTrpsCnt[0].secondary_trps_not_asgnd_vhcls || 0
                        }}</span>
                        <span class="tr-mini-label">Not Defined</span>
                      </div>
                    </div>
                  </div>
                  <div class="tr-sub-section">
                    <p class="tr-sub-title">Routes Vehicles</p>
                    <div class="tr-sub-row">
                      <div class="tr-mini-card tr-teal-light">
                        <span class="tr-mini-value">{{
                          ttlTrpsCnt[0].secondary_rts_dfnd_vhcls || 0
                        }}</span>
                        <span class="tr-mini-label">Defined</span>
                      </div>
                      <div class="tr-mini-card tr-amber">
                        <span class="tr-mini-value">{{
                          ttlTrpsCnt[0].secondary_rts_not_dfnd_vhcls || 0
                        }}</span>
                        <span class="tr-mini-label">Not Defined</span>
                      </div>
                    </div>
                  </div>
                  <div class="tr-sub-section">
                    <p class="tr-sub-title">Trips</p>
                    <div class="tr-sub-row">
                      <div class="tr-mini-card tr-orange-light">
                        <span class="tr-mini-value">{{
                          ttlTrpsCnt[0].secondary_def_trps || 0
                        }}</span>
                        <span class="tr-mini-label">Defined</span>
                      </div>
                      <div class="tr-mini-card tr-green">
                        <span class="tr-mini-value">{{
                          ttlTrpsCnt[0].secondary_trvl_trps || 0
                        }}</span>
                        <span class="tr-mini-label">Travelled</span>
                      </div>
                      <div class="tr-mini-card tr-red-light">
                        <span class="tr-mini-value">{{
                          ttlTrpsCnt[0].secondary_nt_trvl_trps || 0
                        }}</span>
                        <span class="tr-mini-label">Not Travelled</span>
                      </div>
                    </div>
                  </div>
                  <div class="tr-sub-section">
                    <p class="tr-sub-title">Routes</p>
                    <div class="tr-sub-row">
                      <div class="tr-mini-card tr-amber">
                        <span class="tr-mini-value">{{
                          ttlTrpsCnt[0].secondary_rts_dfnd || 0
                        }}</span>
                        <span class="tr-mini-label">Defined</span>
                      </div>
                      <div class="tr-mini-card tr-green">
                        <span class="tr-mini-value">{{
                          ttlTrpsCnt[0].secondary_trckd_rts || 0
                        }}</span>
                        <span class="tr-mini-label">Tracked</span>
                      </div>
                      <div class="tr-mini-card tr-purple">
                        <span class="tr-mini-value">{{
                          ttlTrpsCnt[0].secondary_rte_dvtd || 0
                        }}</span>
                        <span class="tr-mini-label">Deviated</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      }

      <h1
        class="hdrTxt_sm hdrSdLbls"
        style="text-align: center; text-transform: capitalize"
      >
        GRAMEEN
      </h1>
      <ul class="cards">
        @for (d of tdyCoveredTrips; track d) {
        <li class="cards_item">
          <div
            class="card_g"
            style="
              background: linear-gradient(135deg, #63badb 0%, #35a1af 100%);
            "
            (click)="cardFive()"
            [ngClass]="crdFive == true ? 'active_class' : 'normalclass'"
          >
            <div class="card_content">
              <div class="row">
                <h1 class="crdHdr">Vehicles</h1>
              </div>
              <div class="row">
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{ d.actve_rural_ttl === null ? "0" : d.actve_rural_ttl }}
                  </h1>
                  <h1 class="card_sub_title">Active</h1>
                </div>
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{ d.inact_rural_ttl === null ? "0" : d.inact_rural_ttl }}
                  </h1>
                  <h1 class="card_sub_title">Spare</h1>
                </div>
              </div>
            </div>
          </div>
        </li>
        } @for (d of tdyCoveredTrips; track d) {
        <li class="cards_item">
          <div
            class="card_g"
            style="
              background: linear-gradient(135deg, #7f75e5 0%, #4e49b9 100%);
            "
            (click)="cardSix()"
            [ngClass]="crdSix == true ? 'active_class' : 'normalclass'"
          >
            <div class="card_content">
              <div class="row">
                <h1 class="crdHdr">Operational Status</h1>
              </div>
              <div class="row">
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{ d.r_operated === null ? "0" : d.r_operated }}
                  </h1>
                  <h1 class="card_sub_title">Operated</h1>
                </div>
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{ d.r_opper === null ? "0" : d.r_opper }} %
                  </h1>
                  <h1 class="card_sub_title">Operated %</h1>
                </div>
              </div>
              <div class="row">
                <p class="crdFtr">
                  VEHICLES TRAVELLED > 500 Meters IS CONSIDERED AS OPERATED
                </p>
              </div>
            </div>
          </div>
        </li>
        } @for (d of ttlDstncCnt; track d) {
        <li class="cards_item">
          <div
            class="card_g"
            style="
              background: linear-gradient(135deg, #9267d9 0%, #683eb5 100%);
            "
            (click)="cardSeven()"
            [ngClass]="crdSeven == true ? 'active_class' : 'normalclass'"
          >
            <div class="card_content">
              <div class="row">
                <h1 class="crdHdr">Vehicles Travelled</h1>
              </div>
              <div class="row">
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{ d.rrl_tdydst_abv30 === null ? "0" : d.rrl_tdydst_abv30 }}
                  </h1>
                  <h1 class="card_sub_title">>= 30km</h1>
                </div>
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{ d.rrl_tdydst_blw30 === null ? "0" : d.rrl_tdydst_blw30 }}
                  </h1>
                  <h1 class="card_sub_title">< 30km</h1>
                </div>
              </div>
            </div>
          </div>
        </li>
        } @for (d of tdyCoveredTrips; track d) {
        <li class="cards_item">
          <div
            class="card_g"
            style="
              background: linear-gradient(135deg, #63b5f5 0%, #449ee5 100%);
            "
            (click)="cardEight()"
            [ngClass]="crdEight == true ? 'active_class' : 'normalclass'"
          >
            <div class="card_content">
              <div class="row">
                <h1 class="crdHdr">Distance covered</h1>
              </div>
              <div class="row">
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{ d.r_dst === null ? 0 : d.r_dst }}
                  </h1>
                  <h1 class="card_sub_title">Total Distance</h1>
                </div>
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{ d.r_avg_dst === null ? 0 : d.r_avg_dst }}
                  </h1>
                  <h1 class="card_sub_title">Average</h1>
                </div>
              </div>
            </div>
          </div>
        </li>
        }
      </ul>
    </div>
  </div>
  <!-- <div class="row bg-wp">
  <h1>Trips Travelled Last 7Days </h1>
  <div id="ctgrytripsTavelledChart"></div>
</div> -->
  @if (crdOne==true) {
  <div class="row bg-wp">
    <h1>ULB Wise vehicles Status (URBAN)</h1>
    <div id="urbanVehiclesChart"></div>
  </div>
  } @if (crdTwo==true) {
  <div class="row bg-wp">
    <h1>ULB Wise vehicles Operational Status (URBAN)</h1>
    <div id="urbanoperStatusChart"></div>
  </div>
  } @if (crdThree==true) {
  <div class="row bg-wp">
    <h1>ULB Wise Travelled Vehicles (URBAN)</h1>
    <div id="urbantrvlVhcleChart"></div>
  </div>
  } @if (crdFour==true) {
  <div class="row bg-wp">
    <h1>ULB Wise Trips Covered (URBAN)</h1>
    <div id="urbantripCvrdChart"></div>
  </div>
  } @if (crdFive==true) {
  <div class="row bg-wp">
    <h1>ULB Wise vehicles Status (RURAL)</h1>
    <div id="ruralVehiclesChart"></div>
  </div>
  } @if (crdSix==true) {
  <div class="row bg-wp">
    <h1>ULB Wise vehicles Operational Status (RURAL)</h1>
    <div id="ruraloperStatusChart"></div>
  </div>
  } @if (crdSeven==true) {
  <div class="row bg-wp">
    <h1>ULB Wise Travelled Vehicles (RURAL)</h1>
    <div id="ruraltrvlVhcleChart"></div>
  </div>
  }
  <div class="row bg-wp">
    <h1>ULB wise trips</h1>
    <div class="ds-card grid tbl">
      <app-data-grid
        [totalItems]="gridTotals0"
        [groupItems]="gridGroups0"
        class="p-8"
        style="width: 100%"
        [dataSource]="ulbTripsDta"
        [legacyColumns]="ulbTripscolumnDefs"
        [searchPanel]="true"
        [filterRow]="false"
        [filterPanel]="false"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="true"
        exportFileName="ULB Trips Data"
        [pageSize]="10"
        [allowedPageSizes]="[10, 25, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
        [wordWrapEnabled]="true"
        [cellPrepared]="bound_onCellPrepared"
      >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="true"
          type="buttons"
          [width]="100"
          caption="View"
          cellTemplate="editTemplate"
        ></app-grid-column>
        <ng-template appGridCell="editTemplate" let-data="cell"
          ><div>
            <div class="tblEdtBtn" (click)="gotoUlb(data)">
              <i nz-icon nzType="node-index" nzTheme="outline"></i>
              <p>Quick View</p>
            </div>
          </div></ng-template
        >
      </app-data-grid>
    </div>
  </div>
  @if (ShowClap) {
  <div class="row bg-wp">
    <h1>Vendor wise operated vehicles and operated %</h1>
    <div class="ds-card tbl grid">
      <app-data-grid
        [totalItems]="gridTotals1"
        class="p-8"
        style="width: 100%"
        [dataSource]="ulbVndrwseopratedTripsTble"
        [legacyColumns]="ulbVndrwseopratedTripsTblecolumnDefs"
        [searchPanel]="true"
        [filterRow]="false"
        [filterPanel]="false"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="true"
        exportFileName="ulb wise operated Trips"
        [pageSize]="10"
        [allowedPageSizes]="[10, 25, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
        [wordWrapEnabled]="true"
      >
        <!---->
      </app-data-grid>
    </div>
  </div>
  }
</div>
